(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("aframe"));
	else if(typeof define === 'function' && define.amd)
		define(["aframe"], factory);
	else if(typeof exports === 'object')
		exports["Web2VR"] = factory(require("aframe"));
	else
		root["Web2VR"] = factory(root["aframe"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE_aframe__) {
return 